import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  IProductGroup,
  ProductSuggestion,
  IProductsReducer
} from 'modules/ScrShopNew/store/slices/products/types';

const initialState: IProductsReducer = {
  groups: [],
  isLoading: true,
  suggestions: [],
  isMadeCroppingChanges: false
};

const productsSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    fetchProductsAction(state) {
      state.isLoading = true;
    },
    fetchProductsActionSuccess(state, action: PayloadAction<IProductGroup[]>) {
      state.groups = action.payload;
      state.isLoading = false;
    },
    // Terminal marker for the request: success, a skipped fetch (print shop off) and a failure all
    // end here, so `isLoading` means "we don't know yet" instead of staying true forever.
    finishProductsFetch(state) {
      state.isLoading = false;
    },
    fetchProductSuggestionSuccess(state, action: PayloadAction<ProductSuggestion[]>) {
      state.suggestions = action.payload;
    },
    setMadeCroppingChanges(state, action: PayloadAction<boolean>) {
      state.isMadeCroppingChanges = action.payload;
    }
  }
});

export const {
  fetchProductsAction,
  fetchProductsActionSuccess,
  finishProductsFetch,
  fetchProductSuggestionSuccess,
  setMadeCroppingChanges
} = productsSlice.actions;

export const productsReducer = productsSlice.reducer;
